export class UserError extends Error {
  constructor(userMessages: string[]) {
    super();
    this.userMessages = userMessages;
  }

  userMessages: string[] = [];
}
